import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import { Checkbox } from "@progress/kendo-react-inputs";
import { DropDownButton, DropDownButtonItem } from "@progress/kendo-react-buttons";
import Button from "../buttons/Button";
import Tooltip from "../forms/Tooltip";
import "./SelectionMenu.scss";
import { HeaderThElement } from '@progress/kendo-react-data-tools';
import { useGridData } from "./GridDataContext";

const SelectionDropdown = memo(({ disabled, actions, buttonSelection }) => {
  const items = useMemo(() => {
    const baseItems = [
      <DropDownButtonItem key="all" render={(props) => (<Button {...props} label="Všetko" onClick={() => buttonSelection(0)} />)} />,
      <DropDownButtonItem key="none" render={(props) => (<Button {...props} label="Žiadne" onClick={() => buttonSelection(1)} />)} />
    ];

    if (actions?.length) {
      baseItems.push(...actions.map((item, idx) => (
        <DropDownButtonItem
          key={idx + 2}
          render={(props) => (
            <Button
              {...props}
              label={item.label}
              onClick={item.action}
              title={item.tooltip}
            />
          )}
        />
      )));
    }

    return baseItems;
  }, [actions, buttonSelection]);

  return (
    <DropDownButton
      icon="arrow-60-down"
      disabled={disabled}
      className="selection-dropdown"
      popupSettings={POPUP_SETTINGS}
    >
      {items}
    </DropDownButton>
  );
});

const POPUP_SETTINGS = { popupClass: "selection-popup" }
/**
 * Selection menu component
 * @module
 * @param {array} [actions] - Array of actions
 * @param {bool} [checked] - Is checkbox checked?
 * @param {bool} [disabled] - Is checkbox disabled?
 * @param {func} buttonSelection - Button selection function
 * @param {number} selectedCount - Count of selected items
 */

const SelectionMenu = (props) => {
  const { actions, disabled, buttonSelection, thProps } = props;

  const selected = useGridData("selected");
  const selectedCount = selected.length;
  const data = useGridData("data")
  const checked = !selectedCount ? false : data?.length === selectedCount ? true : null//selectedCount === 0 ? false : (selectedCount === 1 ? true : null);
  const getTooltip = () => {
    if (selectedCount) {
      if (selectedCount === 1) {
        return "1 označený záznam";
      }
      if (selectedCount <= 4) {
        return `${selectedCount} označené záznamy`;
      }
      return `${selectedCount} označených záznamov`;
    }
    return "";
  };

  return (
    <HeaderThElement {...thProps} className={`selection-cell ${thProps.className}`} title={getTooltip()}>
      <Tooltip parentTitle={true}>
        <Checkbox label={""} disabled={disabled} value={checked} onChange={() => buttonSelection(checked === null || checked === true ? 1 : 0)} />
        <SelectionDropdown
          disabled={disabled}
          actions={actions}
          buttonSelection={buttonSelection}
        />
      </Tooltip>
    </HeaderThElement >
  );
};

SelectionMenu.propTypes = {
  actions: PropTypes.array,
  checked: PropTypes.bool,
  buttonSelection: PropTypes.func.isRequired,
  selectedCount: PropTypes.number,
};

export default SelectionMenu;
